/** Map GraphQL error extensions.code to i18n key */
export function mapAuthErrorToI18nKey(
  code: string,
  context: "magicLink" | "oauth" | "verify",
): string {
  const mapping: Record<string, Record<string, string>> = {
    BAD_USER_INPUT: {
      verify: "auth.errors.invalidLink",
      oauth: "auth.errors.oauthFailed",
      magicLink: "auth.errors.invalidEmail",
    },
    RATE_LIMITED: {
      verify: "auth.errors.rateLimited",
      oauth: "auth.errors.rateLimited",
      magicLink: "auth.errors.rateLimited",
    },
    UNAUTHENTICATED: {
      verify: "auth.errors.linkExpired",
      oauth: "auth.errors.oauthExpired",
      magicLink: "auth.errors.generic",
    },
  };
  return mapping[code]?.[context] ?? "auth.errors.generic";
}
